import { render, staticRenderFns } from "./registrationrecordetail.vue?vue&type=template&id=3ee33f30&scoped=true"
import script from "./registrationrecordetail.vue?vue&type=script&lang=js"
export * from "./registrationrecordetail.vue?vue&type=script&lang=js"
import style0 from "./registrationrecordetail.vue?vue&type=style&index=0&id=3ee33f30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee33f30",
  null
  
)

export default component.exports